import { LineData } from "components/charting/types/Chart.types";
import { createContext } from "react";

export type ChartDataContextType = LineData[];

const ChartDataContext = createContext<ChartDataContextType | undefined>(undefined);

export default ChartDataContext;
